const channelRequestStatusEnum = Object.freeze({
  NEW: 0,
  IN_PROCESS: 1,
  COMPLETE: 2,
  CANCELED: 3
})

export { channelRequestStatusEnum }



// WEBPACK FOOTER //
// ./src/modules/settings/enum/ChannelRequestStatusEnum.js